import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  styled,
  tableCellClasses,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PoolParticipant } from '../room/types';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: '2px',
    maxWidth: '100px',
  },
}));

type PropTypes = {
  poolParticipants?: PoolParticipant[];
};

export const PoolParticipants = ({ poolParticipants }: PropTypes) => {
  return (
    <>
      <Typography variant="h5" mb={2}>
        Participants
      </Typography>
      <TableContainer component={Paper}>
        <Table stickyHeader size="small" aria-label="sticky table">
          <TableHead>
            <TableRow>
              <StyledTableCell width={'5%'}></StyledTableCell>
              <StyledTableCell width={'5%'}></StyledTableCell>
              <StyledTableCell width={'70%'}>Username</StyledTableCell>
              <StyledTableCell width={'10%'}>Wins</StyledTableCell>
              <StyledTableCell width={'10%'}>Hcap</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {poolParticipants?.map((p, i) => (
              <TableRow key={p.username}>
                <StyledTableCell>{i + 1}.</StyledTableCell>
                <StyledTableCell>
                  <Avatar
                    src={p.avatarUrl}
                    variant="rounded"
                    sx={{ height: 30, width: 30 }}
                  >
                    {!p.avatarUrl ? p.username.charAt(0) : null}
                  </Avatar>
                </StyledTableCell>
                <StyledTableCell>{p.username}</StyledTableCell>
                <StyledTableCell>{p.wins}</StyledTableCell>
                <StyledTableCell>{p.handicap}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
